import React from 'react';
import Container from 'emerald-ui/lib/Container';
import Row from 'emerald-ui/lib/Row';
import Col from 'emerald-ui/lib/Col';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs(
    [
      { component: Container, componentName: 'Container' },
      { component: Row, componentName: 'Row' },
      { component: Col, componentName: 'Col' },
    ],
    'Layout'
  ),
  description: (
    <span>
      There are three components used to organize and define Layout in Emerald-UI: <br />
      <span className="code">Container</span> defines the horizontal boundaries.
      <br />
      <span className="code">Row</span> divides the Container vertically in sections.
      <br />
      <span className="code">Col</span> defines a column within the Row. You can pass the four screen sizes (xs, sm, md
      and lg) to indicate its width for the specified size. Taking into account that the Layout is based on a 12-column
      grid, if you want to have one column, you need to make it 12 units wide. If you want to have 3 columns, you need
      to make them 4 units wide, and so on.
    </span>
  ),
  codeSamples: [
    {
      title: 'Default',
      scope: { Container, Row, Col },
      code: `<Container>
  <p>You can use Col components without specifying a width. They will occupy the available space.</p>
  <Row>
    <Col className="sample-col">No Col width specified</Col>
    <Col className="sample-col">No Col width specified</Col>
    <Col className="sample-col">No Col width specified</Col>
  </Row>
  <p>You can specify the width of certain components. The rest will occupy the remaining space.</p>
  <Row>
    <Col className="sample-col">No Col width specified</Col>
    <Col xs={6} className="sample-col">Col 6</Col>
    <Col className="sample-col">No Col width specified</Col>
  </Row>
  <p>The Cols will wrap when there is no space to fit them horizontally.</p>
  <Row>
    <Col xs={12} className="sample-col">Col 12</Col>
    <Col xs={6} className="sample-col">Col 6</Col>
    <Col xs={6} className="sample-col">Col 6</Col>
    <Col xs={4} className="sample-col">Col 4</Col>
    <Col xs={4} className="sample-col">Col 4</Col>
    <Col xs={4} className="sample-col">Col 4</Col>
  </Row>
</Container>`,
    },
  ],
};
